import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20gradient%20abstract%20background%20with%20soft%20amber%20and%20coral%20tones%2C%20subtle%20ink%20texture%2C%20reading%20atmosphere%2C%20cozy%20library%20vibe%2C%20artistic%20minimal%20composition%2C%20soft%20lighting&width=1400&height=500&seq=cta-bg-manhwa&orientation=landscape"
            alt="韩漫在线阅读"
            title="开始您的韩漫阅读之旅"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
          <div className="relative z-10 px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                准备好开始您的<strong className="text-accent-300">韩漫之旅</strong>了吗？
              </h2>
              <p className="text-sm md:text-base text-background-50/70 mt-2 max-w-md">
                数百部精选韩国漫画等你来探索，即刻开启免费阅读体验！
              </p>
            </div>
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap flex-shrink-0 cursor-pointer"
            >
              立即浏览漫画库
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}